import React from 'react';
import '../../css/side/SearchBox.css'; // 새로운 CSS 파일로 분리 추천

const SearchBox = ({ value, onChange, placeholder, onSearch }) => (
  <div className="custom-search-box">
    <input
      type="text"
      className="custom-search-input"
      placeholder={placeholder || "Search..."}
      value={value}
      onChange={onChange}
      onKeyDown={e => { if (e.key === 'Enter' && onSearch) onSearch(); }}
    />
    <button
      className="custom-search-btn"
      onClick={onSearch}
      type="button"
      tabIndex={-1}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <circle cx="11" cy="11" r="8" stroke="#fff" strokeWidth="2"/>
        <line x1="17" y1="17" x2="21" y2="21" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    </button>
  </div>
);

export default SearchBox;